import { DialogRef } from '@angular/cdk/dialog';
import { ConnectionPositionPair } from '@angular/cdk/overlay';
import { Component, DestroyRef, ElementRef, inject, Input } from '@angular/core';
import { takeUntilDestroyed } from '@angular/core/rxjs-interop';
import { AlertService, NotificationService } from '@app/core';
import { ContentType } from '@app/core/models/content-type.enum';
import { CourseContent } from '@app/core/models/course-content';
import { SubdivionService } from '@app/core/services/subdivisions.service';
import { Popover, Strategy } from '@app/shared/modules/template/components/popover';
import { EMPTY } from '@app/shared/modules/user-photo/user-photo.component';
import { notNull } from '@app/shared/utils';
import { isEmpty } from 'lodash';
import { map, Observable } from 'rxjs';
import { StudioFilterService } from '../../services';
import { PopoverSubdivisionsComponent } from '../popover-subdivisions/popover-subdivisions.component';

@Component({
  selector: 'app-tree-subdivision',
  templateUrl: './tree-subdivision.component.html',
  standalone: false,
})
export class TreeSubdivisionComponent {
  private readonly subdivionService = inject(SubdivionService);
  private readonly notificationService = inject(NotificationService);
  private readonly studioFilterService = inject(StudioFilterService);
  private readonly alertService = inject(AlertService);
  private readonly popover = inject(Popover);
  private readonly dialogRef = inject(DialogRef);
  private readonly destroyRef = inject(DestroyRef);
  public readonly strategy = Strategy;
  public readonly empty = EMPTY;
  @Input() public subdivision: CourseContent;
  @Input() public course_slug: string;
  @Input() public last: boolean = false;
  @Input() public first: boolean = false;
  @Input() public items: CourseContent[];

  public popoverResult$: Observable<any>;

  public get hasItems(): boolean {
    return !isEmpty(this.subdivision.items);
  }

  public isSubdivision(item: CourseContent): boolean {
    return item.tipo === ContentType.Subdivisao;
  }

  public isTrail(item: CourseContent): boolean {
    return item.tipo === ContentType.Trilha;
  }

  public isOdd(): boolean {
    return this.subdivision.ordem % 2 !== 0;
  }

  public setOrder(reordenar: number): void {
    this.subdivionService.setOrder(this.subdivision.id, reordenar).subscribe(() => {
      this.notificationService.success('geral.sucesso');
      this.getSubdivisions();
    });
  }

  public onOpenPopover(elementRef: ElementRef, positionStrategy: ConnectionPositionPair[] = []): void {
    this.subdivionService.closeModal$.next(false);
    this.subdivionService.closeModal$
      .pipe(takeUntilDestroyed(this.destroyRef), notNull())
      .subscribe(() => this.dialogRef.close());
    this.popoverResult$ = this.popover.open(PopoverSubdivisionsComponent, {
      positionStrategy,
      elementRef,
      data: { item: this.subdivision, items: this.items },
    }).closed;
  }

  public getSubdivisions() {
    this.subdivionService
      .getSubdivision(this.subdivision.curso_id)
      .pipe(
        takeUntilDestroyed(this.destroyRef),
        notNull(),
        map((resp) => resp.data),
      )
      .subscribe({
        next: (data) => {
          this.studioFilterService.passItems(data);
        },
        error: (e) => this.alertService.alert({ message: e.error.msg }),
      });
  }
}
